import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scrollTo";

const LINKS = [
  { id: "method", label: "The Method", testid: "nav-link-proprietary" },
  { id: "gallery", label: "Gallery", testid: "nav-link-gallery" },
  { id: "process", label: "Process", testid: "nav-link-process" },
  { id: "pricing", label: "Pricing", testid: "nav-link-pricing" },
  { id: "stories", label: "Stories", testid: "nav-link-testimonials" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#0C0A09]/75 border-b border-stone-800/60">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-brand-logo"
          onClick={() => window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.4 }) : window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center hover:opacity-85 transition-opacity duration-300"
          aria-label="PETRAITS home"
        >
          <img src="/logo.png" alt="PETRAITS by Bash & Bird" className="h-12 w-12 rounded-full" />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="text-sm tracking-wide text-stone-400 hover:text-[#41C2F2] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-consultation"
            onClick={() => go("consult")}
            className="text-sm font-medium px-5 py-2.5 rounded-full border border-[#41C2F2]/60 text-[#41C2F2] hover:bg-[#41C2F2] hover:text-[#0C0A09] transition-colors duration-300"
          >
            Request Consultation
          </button>
        </nav>

        <button
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-stone-300 p-2"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-mobile-drawer"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden overflow-hidden bg-[#0C0A09]/95 border-b border-stone-800/60"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-${l.id}`}
                  onClick={() => go(l.id)}
                  className="text-left font-serif text-2xl text-stone-200 hover:text-[#41C2F2] transition-colors"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="nav-mobile-cta-consultation"
                onClick={() => go("consult")}
                className="mt-2 text-center font-medium px-5 py-3 rounded-full bg-[#41C2F2] text-[#0C0A09]"
              >
                Request Consultation
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
